import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const SortDesc: TIconComponent = props => (
    <Icon viewBox="0 0 24 24" {...props}>
        <path
            d="m18 20c-0.5523 0-1-0.4477-1-1v-16c0-0.55229 0.4477-1 1-1s1 0.44771 1 1v16c0 0.5523-0.4477 1-1 1z"
            clipRule="evenodd"
            fill="inherit"
            fillRule="evenodd"
        />
        <path
            d="m18.447 20.894c-0.2815 0.1408-0.6129 0.1408-0.8944 0l-4-2c-0.494-0.247-0.6942-0.8476-0.4472-1.3416s0.8476-0.6942 1.3416-0.4472l3.5528 1.7764 3.5528-1.7764c0.494-0.247 1.0946-0.0468 1.3416 0.4472s0.0468 1.0946-0.4472 1.3416l-4 2z"
            clipRule="evenodd"
            fill="inherit"
            fillRule="evenodd"
        />
        <rect x="2" y="19" width="7" height="2" rx="1" fill="inherit" />
        <rect x="2" y="15" width="9" height="2" rx="1" fill="inherit" />
        <rect x="2" y="11" width="11" height="2" rx="1" fill="inherit" />
        <rect x="2" y="7" width="13" height="2" rx="1" fill="inherit" />
    </Icon>
);
